module.exports = __webpack_public_path__ + "img/004.dace7b6c.png";